import { OptionType } from "./RulesModal.types";

/**
 * Convert object {0: "=", 1: "!="} into react-select options.
 */
export const optionRenderer = (obj: Record<number, string>): OptionType[] => {
  return Object.values(obj).map(v => ({ id: v, value: v, label: v }));
};

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result as string);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};
